import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {Tour} from '@app/common/interfaces/tour';
import {TranslatePipe} from '@ngx-translate/core';
import {Component, inject, OnInit} from '@angular/core';
import {ShoppingService} from '@app/common/services/shopping.service';
import {AppStateService} from '@app/common/services/app-state.service';
import {BookOnlineSectionComponent, HeaderComponent, PricesTableComponent} from '@app/common/ui-kits';

@Component({
  selector: 'app-shopping-cart-page',
  templateUrl: './shopping-cart-page.component.html',
  styleUrls: ['./shopping-cart-page.component.scss'],
  imports: [
    HeaderComponent,
    TranslatePipe,
    PricesTableComponent,
    BookOnlineSectionComponent
  ]
})
export class ShoppingCartPageComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  public readonly shoppingService = inject(ShoppingService);
  public readonly settingsService = inject(AppStateService);

  public math = Math;

  ngOnInit() {
  }

  public removeTour(index: number): void {
    this.shoppingService.shoppedTours.splice(index, 1);
    this.shoppingService.shoppedToursIds.splice(index, 1);
    // setItemStore<Tour[]>('shoppedTours', this.shoppingService.shoppedTours);
    // setItemStore<string[]>('shoppedToursIds', this.shoppingService.shoppedToursIds);
    this.shoppingService.getTotalToursPrice();
    if (!this.shoppingService.shoppedTours.length) {
      this.location.back();
    }
  }

  public goToTour(tour: Tour): void {
    this.router.navigate(['tour', tour.urlKey]);
  }

}
